import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SocialProofMini() {
  const testimonials = [{
    initials: 'MR',
    quote: 'Organicé todo el año pianístico en una tarde. Cada clase pensada y secuenciada para los 4 niveles. Antes me llevaba todos los domingos.',
    author: 'María R., Buenos Aires',
    role: 'Profesora particular, 22 alumnos'
  }, {
    initials: 'JC',
    quote: '24 piezas con progresión clara. Los alumnos avanzan clase a clase y se nota. Nunca más improvisar el repertorio.',
    author: 'Jorge C., Rosario',
    role: 'Profesor en Conservatorio + clases particulares'
  }, {
    initials: 'SV',
    quote: 'Adapto el mismo contenido a todos los niveles en 5 minutos. Antes me llevaba horas de un domingo entero.',
    author: 'Sofía V., Córdoba',
    role: 'Profesora independiente, 35 alumnos'
  }];
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);
  const goNext = useCallback(() => {
    setDirection(1);
    setCurrent(prev => (prev + 1) % testimonials.length);
  }, [testimonials.length]);
  const goPrev = useCallback(() => {
    setDirection(-1);
    setCurrent(prev => (prev - 1 + testimonials.length) % testimonials.length);
  }, [testimonials.length]);
  // Auto-advance every 5 seconds
  useEffect(() => {
    const timer = setInterval(goNext, 5000);
    return () => clearInterval(timer);
  }, [goNext]);
  const t = testimonials[current];
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 200 : -200,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -200 : 200,
      opacity: 0
    })
  };
  return <section className="bg-cream py-12" data-id="element-233">
      <div className="container mx-auto px-6" data-id="element-234">
        <FadeIn data-id="element-235">
          <div className="relative max-w-xl mx-auto" data-id="element-236">
            {/* Arrows */}
            <button onClick={goPrev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 sm:-translate-x-6 z-10 w-9 h-9 rounded-full bg-navy-800 text-gold flex items-center justify-center border border-gold/30 hover:bg-navy-700 transition-colors shadow-md" aria-label="Testimonio anterior" data-id="element-237">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-238" />
            </button>
            <button onClick={goNext} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 sm:translate-x-6 z-10 w-9 h-9 rounded-full bg-navy-800 text-gold flex items-center justify-center border border-gold/30 hover:bg-navy-700 transition-colors shadow-md" aria-label="Testimonio siguiente" data-id="element-239">
              <ChevronRightIcon className="w-5 h-5" data-id="element-240" />
            </button>

            {/* Card */}
            <div className="overflow-hidden px-6" data-id="element-241">
              <AnimatePresence mode="wait" custom={direction} data-id="element-242">
                <motion.div key={current} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
                duration: 0.35,
                ease: 'easeInOut'
              }} className="bg-warmWhite p-6 sm:p-8 rounded-xl shadow-sm border border-gold/10 text-center" data-id="element-243">
                  <div className="flex items-center justify-center gap-3 mb-4" data-id="element-244">
                    <div className="w-10 h-10 rounded-full bg-navy-800 text-gold flex items-center justify-center font-bold text-sm border border-gold/30" data-id="element-245">
                      {t.initials}
                    </div>
                    <div className="flex text-gold text-sm" data-id="element-246">⭐⭐⭐⭐⭐</div>
                  </div>
                  <p className="font-accent italic text-lg text-navy-800 mb-6" data-id="element-247">
                    "{t.quote}"
                  </p>
                  <div data-id="element-248">
                    <p className="font-bold text-navy-900 text-sm" data-id="element-249">
                      {t.author}
                    </p>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-250">{t.role}</p>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Dots */}
            <div className="flex justify-center gap-2 mt-5" data-id="element-251">
              {testimonials.map((_, i) => <button key={i} onClick={() => {
              setDirection(i > current ? 1 : -1);
              setCurrent(i);
            }} className={`w-2 h-2 rounded-full transition-all duration-300 ${i === current ? 'bg-gold w-5' : 'bg-gray-300'}`} aria-label={`Testimonio ${i + 1}`} data-id="element-252" />)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}